import { CRM_WEB_PAGES_URLS } from '../../CRM_WEB_PAGES_URLS';
import { ADMIN_WEB_PAGES_URLS } from '../../EMR_WEB_PAGES_URLS';
import { PATIENT_WEB_PAGES_URLS } from '../../PATIENT_WEB_PAGES_URLS';
import { OrganizationSettings } from '@care-portals/api-interfaces';

export const cover_health: OrganizationSettings = {
  name: 'Cover Health',
  fromEmail: 'help@cover.health',
  replyToEmail: 'help@cover.health',
  ecommerceEnabled: false,
  stripeEnabled: true,
  emrEnabled: true,
  patientPortalDomain: 'cover-health.portals.care',
  noMarketingListId: 'RGYR7Z',
  conversationServiceId: 'IS4baec316c27d4643b9460d481449f745',
  adminCustomDomain: 'emr.portals.care',
  appointmentconsentSection: `
    <p style="text-align: center;color: #536476;">
    By clicking on {{cta_label}} you agree to our:<br />
    <a
      href="javascript:window.open('https://cover.health/privacy-policy', 'popup', 'width=600,height=600');"
    >
        Privacy Policies
    </a>
    <br>
    <a
      href="javascript:window.open('https://cover.health/terms-conditions', 'popup', 'width=600,height=600');"
    >
    Terms & Conditions
    </a>
      </p>
    `,

  // navigation
  crmWebAppLayout: {
    title: 'Cover Health',
    logo: 'https://cover.health/wp-content/uploads/2020/04/cropped-cover-health-logo.png',
    emrPatientLink:
      'https://cover-health.kai-oscar.com/oscar/demographic/demographiccontrol.jsp?displaymode=edit&dboperation=search_detail&demographic_no=',
    mainMenu: [
      {
        title: 'Leads',
        link: CRM_WEB_PAGES_URLS.leads.list,
        icon: 'fa-regular fa-address-book',
        roles: ['*']
      },
      {
        title: 'Appointments',
        link: CRM_WEB_PAGES_URLS.appointments.calendar,
        icon: 'fa-regular fa-calendar-check',
        roles: ['*']
      },
      {
        title: 'Tasks',
        link: CRM_WEB_PAGES_URLS.tasks.list,
        icon: 'fa-solid fa-list-check',
        roles: ['*']
      },
      {
        title: 'Segments',
        link: CRM_WEB_PAGES_URLS.segment.list,
        icon: 'fa-solid fa-table-columns',
        roles: ['*']
      },
      {
        title: 'Admin',
        link: '',
        icon: 'fas fa-user-cog',
        roles: ['admin', 'developer', 'owner'],
        items: [
          {
            title: 'Services',
            link: CRM_WEB_PAGES_URLS.services.list,
            icon: 'fas fa-medkit'
          },
          {
            title: 'Schedules',
            link: CRM_WEB_PAGES_URLS.schedules.list,
            icon: 'fas fa-calendar'
          },
          {
            title: 'Users',
            link: CRM_WEB_PAGES_URLS.users.list,
            icon: 'fas fa-lock'
          },
          {
            title: 'Forms',
            link: CRM_WEB_PAGES_URLS.forms.list,
            icon: 'fas fa-table'
          },
          {
            title: 'Workflows',
            link: CRM_WEB_PAGES_URLS.workflows.list,
            icon: 'fas fa-code-branch'
          },
          {
            title: 'Templates',
            link: CRM_WEB_PAGES_URLS.emailTemplates.list,
            icon: 'fas fa-palette'
          },
          {
            title: 'Settings',
            link: CRM_WEB_PAGES_URLS.settings.base,
            icon: 'fa-solid fa-sliders'
          }
        ]
      }
    ]
  },
  emrWebAppLayout: {
    title: 'Cover Health',
    defaultPingMsg:
      '🛎️ Ping! Cover Health care team is waiting for your response. To respond, please go to https://cover-health.portals.care/appointments',

    mainMenu: [
      {
        title: 'Patients',
        link: ADMIN_WEB_PAGES_URLS.customers.allList,
        icon: 'fas fa-user-injured',
        roles: ['*']
      },
      /*
        {
          title: 'Appointments',
          link: ADMIN_WEB_PAGES_URLS.appointments.allList,
          icon: 'fas fa-calendar-check',
          roles: ['admin', 'owner']
        },
        */
      {
        title: 'Appointments',
        link: ADMIN_WEB_PAGES_URLS.appointments.calendar,
        icon: 'fas fa-calendar-check',
        roles: ['*']
      }
      /*
        {
          title: 'My Sessions',
          link: ADMIN_WEB_PAGES_URLS.appointments.myList,
          icon: 'fas fa-calendar-day',
          roles: ['provider'],
          subMenu: [
            {
              title: 'Current Encounter',
              link: ADMIN_WEB_PAGES_URLS.encounter.current
            },
            {
              title: 'Seen Today',
              link: ADMIN_WEB_PAGES_URLS.appointments.myList
            }
          ]
        },
        // {
        //   title: 'Schedule',
        //   link: ADMIN_WEB_PAGES_URLS.users.schedule,
        //   icon: 'fas fa-calendar-alt',
        //   roles: ['*']
        // },

        */
    ]
  },
  patientWebAppLayout: {
    title: 'Cover Health',
    brand: 'cover-health',
    theme: 'cover',
    shopUrl: 'http://cover.health',
    privacyPolicyUrl: 'https://cover.health/privacy-policy',
    termsOfUseUrl: 'https://cover.health/privacy-policy',
    stripePublicKey:
      'pk_live_51HSkz2LFS60TMpFNhu3IXiIAU4AgPyiFS9aqeT6tYwb4ICOdnFV905ivU1NpvtpYdTyViasZwwJNcThcf0w4HoCw00v3GxM1f4',
    mainMenu: [
      {
        title: 'Profile',
        link: PATIENT_WEB_PAGES_URLS.account.profile,
        svg: 'assets/icons/profile.svg',
        roles: ['*']
      },
      {
        title: 'Appointments',
        link: PATIENT_WEB_PAGES_URLS.account.appointments,
        svg: 'assets/icons/appointments.svg',
        roles: ['*']
      },
      {
        title: 'Billing',
        link: 'billing',
        svg: 'assets/icons/billing.svg',
        type: 'external',
        roles: ['*']
      }
      // {
      //   title: 'Messages',
      //   link: PATIENT_WEB_PAGES_URLS.messages.inbox,
      //   icon: 'fas fa-inbox',
      //   roles: ['*']
      // }
    ],
    topAction: {
      title: 'Book Visit',
      link: 'https://cover.health'
    },
    logo: {
      img: '',
      link: 'https://cover.health'
    },
    referrals: {
      enabled: false,
      referrerAmount: 50,
      refereeAmount: 30,
      referralURI: 'https://cover-health.portals.care/auth/signup',
      referralFAQ: 'https://cover.health/referral-rewards/'
    }
  }
};
